module.exports = __webpack_public_path__ + "static/hero-loan-calculator-b75a42a849ee3675702b1a853d1e42b0.webp";